import { DBConnectorService } from './../../../service/test.service';
import { ManageService } from './../../../service/manage.service';
import { SectorModel } from './../../../service/sector.model';
// import { DialogComponent } from 'ng2-bootstrap-modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Component, OnInit } from '@angular/core';
export interface LabelModel {
  // title: string;
  // message: string;
}


@Component({
  selector: 'app-view-labelmapping-modal',
  templateUrl: './view-labelmapping-modal.component.html',
  styleUrls: ['./view-labelmapping-modal.component.css']
})
export class ViewLabelmappingModalComponent implements LabelModel, OnInit {

  // title: string;
  // message: string;
  listLabelMapping = [];
  sectormodel = new SectorModel;
  
  constructor(private bsModalRef: BsModalRef,
    private manage: ManageService,
    private dbconnectorservice: DBConnectorService) {
    // super(dialogService);
    this.sectormodel.SectorName = this.dbconnectorservice.SectorName;
    this.sectormodel.ModelName = this.dbconnectorservice.ModelName;
  }

  showLabelList() {

    this.manage.ShowLabelMapping(this.sectormodel)
      .subscribe(
      (data) => {
        this.listLabelMapping = data;
        //console.log(this.listLabelMapping);
      });
  }
  

  confirm() {
    // we set dialog result as true on click on confirm button, 
    // then we can get dialog result from caller code 
    // this.result = true;
    // this.close();
  }

  closeModal() {
    this.bsModalRef.hide();
  }

  ngOnInit(){
    this.showLabelList();
  }
}

